export const Types = {
  IUnsavedWork: Symbol.for('IUnsavedWork'),
  ILeaveConfirmation: Symbol.for('ILeaveConfirmation'),
  IDataGateway: Symbol.for('IDataGateway'),
  IRouterGateway: Symbol.for('IRouterGateway'),
  ISessionStorageGateway: Symbol.for('ISessionStorageGateway'),
  ILocalStorageGateway: Symbol.for('ILocalStorageGateway'),
  IWindowGateway: Symbol.for('IWindowGateway'),
  IViewportGateway: Symbol.for('IViewportGateway'),
  IDocumentGateway: Symbol.for('IDocumentGateway'),
  IServiceWorkerGateway: Symbol.for('IServiceWorkerGateway'),

  // Multi-bound: every registered participant is resolved together via
  // multiInject. See core/interfaces/user-scoped-state.ts.
  IUserScopedState: Symbol.for('IUserScopedState'),
  IAppLifecycle: Symbol.for('IAppLifecycle'),
  // See core/interfaces/command-source.ts.
  ICommandSource: Symbol.for('ICommandSource'),
  // Singular, not multi-bound — exactly one implementation exists
  // (features/game/active-games.repository.ts). See
  // core/interfaces/active-games-source.ts.
  IActiveGamesSource: Symbol.for('IActiveGamesSource'),
  IClockGateway: Symbol.for('IClockGateway'),
  IIdGeneratorGateway: Symbol.for('IIdGeneratorGateway'),
  IRandomGateway: Symbol.for('IRandomGateway'),
  ILoggingGateway: Symbol.for('ILoggingGateway'),
  ITelemetryGateway: Symbol.for('ITelemetryGateway'),
  IConnectivityGateway: Symbol.for('IConnectivityGateway'),
  IFormatGateway: Symbol.for('IFormatGateway'),
} as const
